import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

export const travelTradeApi = {
  create: (body) => travelClient.post(travelEndpoints.trades, body),
  get: (tradeId) => travelClient.get(travelEndpoints.trade(tradeId)),
  cancel: (tradeId, body) => travelClient.post(travelEndpoints.tradeCancel(tradeId), body || {}),
  pay: (tradeId) => travelClient.post(travelEndpoints.tradePayment(tradeId), {}),
};
